import {
    Component,
    OnInit,
    Input,
    ViewChild,
    TemplateRef,
    Output,
    EventEmitter
} from "@angular/core";
import { BsModalService, BsModalRef } from "ngx-bootstrap";
import { CommonService } from '../../services/index';
@Component({
    selector: "client-history",
    templateUrl: "./clientHistory.html"
})
export class clientHistoryComponent {
    data: any;
    dataval: any;
    columns: any;
    clientdata: any;
    clientdatacnt: any;
    servicedata: any;
    servicecolumns: any;
    servicecnt: any;
    machinedata: any;
    machinecolumns: any;
    machinecnt: any;
    sparedata: any;
    sparecolumns: any;
    sparecnt: any;
    isLoadMask: Promise<any>;
    ezCrmDetail: any = null;
    ezCrmDetailLoading: boolean = false;
    ezCrmModalRef: BsModalRef;
    objectKeys = Object.keys;

    @ViewChild('descTemplate') descTemplate: TemplateRef<any>;
    @ViewChild('ezIconTemplate') ezIconTemplate: TemplateRef<any>;
    @ViewChild('ezCrmDetailModal') ezCrmDetailModal: TemplateRef<any>;

    @Input() set showClientHistory(val: any) {
        this.data = val;
        if (this.data.from_page) {
            let that = this;
            this.isLoadMask = that.commonService
                .getClientHistory(that.data)
                .then(function (res: any) {
                    that.clientdata = res.data;
                    that.servicedata = res.service_history;
                    that.clientdatacnt = res.data ? res.data.length : res.totCnt;
                    that.servicecolumns = res.service_headers;
                    that.servicecnt = res.servicecnt;
                    that.machinedata = res.machine_details;
                    that.machinecnt = res.machinecnt;
                    that.sparedata = res.spare_details;
                    that.sparecnt = res.sparecnt;
                    if (res.data.length > 0 && res.data[0].next_followp_date) {
                        res.data[0].description += " " + res.data[0].next_followp_date;
                    }
                });
        } else {
            this.clientdata = val;
            this.clientdatacnt = this.clientdata.length;
        }
    }

    constructor(public commonService: CommonService, public bsModalRef: BsModalRef, private modalService: BsModalService) {

    }

    viewEzCrmDetail(row: any) {
        this.ezCrmDetail = null;
        this.ezCrmDetailLoading = true;
        this.ezCrmModalRef = this.modalService.show(this.ezCrmDetailModal, { class: 'modal-lg' });
        this.commonService.getEzCrmCallLogDetail(row.ez_id).then((res: any) => {
            this.ezCrmDetailLoading = false;
            this.ezCrmDetail = res && res.status === 'success' ? res : null;
        }).catch(() => {
            this.ezCrmDetailLoading = false;
        });
    }

    closeEzDetail() {
        if (this.ezCrmModalRef) {
            this.ezCrmModalRef.hide();
        }
    }

    ngOnInit(): void {

        this.columns = [
            {
                name: "Date",
                prop: "act_date",
                width: 100,
                minWidth: 100,
                maxWidth: 100,
                toggle: true
            },
            {
                name: "Description",
                prop: "description",
                sortable: false,
                cellTemplate: this.descTemplate,
                width: 380,
                minWidth: 380,
                maxWidth: 380
            },
            {
                name: "Willing Status",
                prop: "follow_up_willing",
                sortable: false,
                width: 120,
                minWidth: 120,
                maxWidth: 120
            },
            {
                name: "Status",
                prop: "status_name",
                sortable: false,
                cellClass: "cell-left",
                width: 150,
                minWidth: 150,
                maxWidth: 150
            }
        ];
        this.machinecolumns = [
            {
                name: "Date",
                prop: "trans_date",
                sortable: false,
                cellClass: "cell-right",
                width: 110,
                minWidth: 110,
                maxWidth: 110
            },
            {
                name: "Model Name",
                prop: "model_name",
                width: 190,
                minWidth: 190,
                maxWidth: 190,
                toggle: true
            },
            {
                name: "Brand Name",
                prop: "brand_name",
                sortable: false,
                width: 190,
                minWidth: 190,
                maxWidth: 190
            },
            {
                name: "MRP",
                prop: "mrp",
                sortable: false,
                cellClass: "cell-left",
                width: 100,
                minWidth: 100,
                maxWidth: 100
            },
            {
                name: "Type",
                prop: "trans_type",
                sortable: false,
                cellClass: "cell-left",
                width: 110,
                minWidth: 110,
                maxWidth: 110
            },
            {
                name: "Free Item",
                prop: "free_item",
                sortable: false,
                cellClass: "cell-left",
                width: 110,
                minWidth: 110,
                maxWidth: 110
            },
            {
                name: "Machine Type",
                prop: "machines",
                sortable: false,
                cellClass: "cell-left",
                width: 130,
                minWidth: 130,
                maxWidth: 130
            }
        ];
        this.sparecolumns = [
            {
                name: "Date",
                prop: "date",
                cellClass: "cell-center",
                width: 110,
                minWidth: 110,
                maxWidth: 110
            },
            {
                name: "Bill No",
                prop: "auto_no",
                sortable: false,
                cellClass: "cell-left",
                width: 75,
                minWidth: 75,
                maxWidth: 75,
                toggle: true
            },
            {
                name: "Model Name",
                prop: "name",
                sortable: false,
                width: 250,
                minWidth: 250,
                maxWidth: 250
            },
            {
                name: "Qty",
                prop: "quantity",
                sortable: false,
                cellClass: "cell-right",
                width: 75,
                minWidth: 75,
                maxWidth: 75
            },
            {
                name: "Amount",
                prop: "amount",
                sortable: false,
                cellClass: "cell-right",
                width: 110,
                minWidth: 110,
                maxWidth: 110
            }
        ];
    }

    ngAfterViewInit() {
        this.columns = [
            {
                name: "Date",
                prop: "act_date",
                width: 100,
                minWidth: 100,
                maxWidth: 100,
                toggle: true
            },
            {
                name: "Description",
                prop: "description",
                sortable: false,
                cellTemplate: this.descTemplate,
                width: 340,
                minWidth: 340,
                maxWidth: 340
            },
            {
                name: "Status",
                prop: "status_name",
                sortable: false,
                cellClass: "cell-left",
                width: 150,
                minWidth: 150,
                maxWidth: 150
            },
            {
                name: "View",
                prop: "ez_id",
                sortable: false,
                cellTemplate: this.ezIconTemplate,
                width: 150,
                minWidth: 150,
                maxWidth: 150
            }
        ];
    }

}



// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/components/common/clientHistory.ts